import {Model} from 'vue-mc';

/**
 * CloneModel model
 */
export default class LayoutModel extends Model {


    // Default attributes that define the "empty" state.
    defaults() {
        return {
            layoutId: "",
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/cloneModel.js